import { useQuery } from '@tanstack/react-query';

import { authUserQueryOptions } from '@user/queries/authUserQueries';
import { userProfileQueryOptions } from '@user/queries/userProfileQueries';

interface Data {
    selectedClinicId?: string;
    isLoaded: boolean;
    isError: boolean;
}

export function useSelectedClinicId(): Data {
    const authUserQuery = useQuery(authUserQueryOptions.current());
    const profileQuery = useQuery({
        ...userProfileQueryOptions.byUserId(authUserQuery.data?.id ?? ''),
        enabled: !!authUserQuery.data?.id,
    });

    return {
        selectedClinicId: profileQuery.data?.additionalData?.selectedOrganizationId ?? undefined,
        isLoaded: profileQuery.data !== undefined,
        isError: authUserQuery.isError || profileQuery.isError,
    };
}
